import React from "react";

const MovementCard = ({
  username,
  contactInfo,
  dateRecieved,
  transferredFrom,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 170,
      }}
    >
      <div
        style={{
          height: "70%",
          width: "85%",

          borderRadius: 8,
          WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
          display: "flex",
        }}
      >
        <div
          style={{
            flex: 0.5,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            maxWidth: "50%",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: "90%",
              fontSize: 12,
              fontWeight: "bold",
              marginBottom: 5,
              marginTop: 10,
            }}
          >
            CONTACT NAME
          </div>
          <div style={{ width: "90%", marginBottom: 10 }}>
            {username ? username : "loading"}
          </div>
          <div
            style={{
              width: "90%",
              fontSize: 12,
              fontWeight: "bold",
              marginBottom: 5,
            }}
          >
            CONTACT NUMBER
          </div>
          <div style={{ width: "90%" }}>{contactInfo}</div>
        </div>
        <div
          style={{
            flex: 0.5,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              fontSize: 12,
              fontWeight: "bold",
              marginBottom: 5,
              marginTop: 10,
            }}
          >
            DATE RECIEVED
          </div>
          <div style={{ width: "90%", marginBottom: 10 }}>{dateRecieved}</div>
          <div
            style={{
              width: "90%",
              fontSize: 12,
              fontWeight: "bold",
              marginBottom: 5,
            }}
          >
            TRANSFERRED FROM
          </div>
          <div style={{ width: "90%" }}>{transferredFrom}</div>
        </div>
      </div>
    </div>
  );
};

export default MovementCard;
